import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@mui/material/IconButton';
import DialogButtom from './DialogButtom';
import EditarPonto from './EditarPonto';

const TreatmentPoint = ({ open, onClose, onCloseTreatment, editPoint, setEditPoint }) => {
    // const [editPoint, setEditPoint] = React.useState(false)
    return (
        <Dialog
            open={open}
            onClose={() => onCloseTreatment(false)}
            maxWidth="md"
            PaperProps={{
                style: {
                    backgroundColor: editPoint ? 'white' : '#4851de',
                    borderRadius: '20px',
                    width: editPoint ? '45%' : '35%',
                    height: '300px'
                },
            }}
        >

            <EditarPonto onCloseTreatment={onCloseTreatment} setEditPoint={setEditPoint} />

        </Dialog>
    );
};

export default TreatmentPoint;

